module.exports = __webpack_public_path__ + "assets/img/3.d88365c7.png";